"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HELP_SUPPORT_URL = void 0;
const HELP_SUPPORT_URL = exports.HELP_SUPPORT_URL = {
  INTERNAL: 'https://targetprod.service-now.com/merch_support',
  EXTERNAL: 'https://www.partnersonline.com/page/help'
};